import Reviews from '../Reviews';

const CalculatorResultAwards = () => {
  return (
    <div className="calculator-result">
      <div className="calculator-result__awards">
        <section className="calculator-result__awards">
          <div className="calculator-result__awards__intro">
            <h2>Award winning excellence</h2>
            <p className="subtitle_1">
              You can rest assured you’re in good hands –{' '}
              <b>
                we won the 2021 Law Society Award for Excellence & the 2022 Modern Law Award for
                Best Use of Technology
              </b>
            </p>
            <div className="calculator-result__awards__img" />
          </div>
        </section>
        <section className="calculator-result__reviews">
          <Reviews>
            <h3>
              Rated 4.8 Stars in Over 1000 <a href="/testimonials">Reviews</a>
            </h3>
            <p>
              You can rest assured that, because we represent individuals only, there is no{' '}
              <span>conflict of interest</span>
            </p>
          </Reviews>
        </section>
      </div>
    </div>
  );
};

export default CalculatorResultAwards;
